// A feltölthető fájltípusok EGYETLEN forrása. A kontrakt (kérés-validálás) és az app-backend
// (jegy-kiadás) is innen olvassa — két külön lista előbb-utóbb kettéfutna, és a szerver-oldali
// kapu csendben lazulna.
//
// Miért kell szerver-oldali kapu egyáltalán: a `contentType` a KLIENSTŐL jön, és a presigned
// letöltő-URL-t az objektum-tár ezzel a fejléccel szolgálja ki. Egy `text/html` vagy
// `image/svg+xml` feltöltés tehát tárolt szkriptet jelentene — nem a Hub origóján (ezért nem
// munkamenet-lopás), de phishing-felületet ad a tár doménjén, és a megosztott linkkel terjed.
/** Beágyazható képek — ezekből lesz a cikkben megjelenő kép. */
export const EMBEDDABLE_IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
];
/**
 * Letölthető csatolmányok. Szándékosan szűk: dokumentum, táblázat, prezentáció, PDF, sima szöveg,
 * és a csomagolt formátumok.
 */
export const ATTACHMENT_DOCUMENT_TYPES = [
    'application/pdf',
    'text/plain',
    'text/csv',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/zip',
];
/**
 * A teljes engedélyezett halmaz.
 *
 * NINCS benne, és nem is kerülhet bele indoklás nélkül:
 * - `image/svg+xml` — szkriptet hordozhat, és képként ágyazódna be (audit T7);
 * - `text/html`, `application/xhtml+xml` — a tár doménjén futó tartalom;
 * - `application/octet-stream` — bármit átengedne, tehát kaput sem érne.
 */
export const ALLOWED_UPLOAD_TYPES = [
    ...EMBEDDABLE_IMAGE_TYPES,
    ...ATTACHMENT_DOCUMENT_TYPES,
];
/**
 * A MIME-típus paraméterei (`; charset=utf-8`) és a kis-nagybetű nem befolyásolják a döntést —
 * az RFC szerint a típus maga nem érzékeny a betűméretre. A `String.prototype.trim` a fejléc-
 * eredetű szóközöket viszi.
 */
export function normalizeContentType(value) {
    return (value.split(';')[0] ?? '').trim().toLowerCase();
}
/** Feltölthető-e ez a `contentType`? A hívónak a NORMALIZÁLATLAN, nyers értéket kell átadnia. */
export function isAllowedUploadType(value) {
    return ALLOWED_UPLOAD_TYPES.includes(normalizeContentType(value));
}
/** Beágyazható képként jelenjen-e meg? Csak megjelenítési döntés, NEM biztonsági határ. */
export function isEmbeddableImageType(value) {
    return EMBEDDABLE_IMAGE_TYPES.includes(normalizeContentType(value));
}
//# sourceMappingURL=upload.js.map